import Start from "../components/pages/Inquiry/Steps/Start";
import Expired from "../components/pages/Inquiry/Steps/Expired";
import StepOne from "../components/pages/Inquiry/Steps/StepOne";
import StepTwo from "../components/pages/Inquiry/Steps/StepTwo";
import StepThree from "../components/pages/Inquiry/Steps/StepThree";
import StepFour from "../components/pages/Inquiry/Steps/StepFour";
import StepFive from "../components/pages/Inquiry/Steps/StepFive";
import StepSix from "../components/pages/Inquiry/Steps/StepSix";
import StepSeven from "../components/pages/Inquiry/Steps/StepSeven";
import StepEight from "../components/pages/Inquiry/Steps/StepEight";
import StepNine from "../components/pages/Inquiry/Steps/StepNine";
import StepTen from "../components/pages/Inquiry/Steps/StepTen";
import StepEleven from "../components/pages/Inquiry/Steps/StepEleven";
import StepTwelve from "../components/pages/Inquiry/Steps/StepTwelve";
import StepThirteen from "../components/pages/Inquiry/Steps/StepThirteen";
import StepFourteen from "../components/pages/Inquiry/Steps/StepFourteen";
import StepFifteen from "../components/pages/Inquiry/Steps/StepFifteen";
import StepSixteen from "../components/pages/Inquiry/Steps/StepSixteen";
import StepSeventeen from "../components/pages/Inquiry/Steps/StepSeventeen";
import StepEighteen from "../components/pages/Inquiry/Steps/StepEighteen";

const inquiry = [
    {
        path: '/onderzoek/:token',
        component: Start,
        name: 'inquiry-start'
    }, {
        path: '/onderzoek/:token/stap-1',
        component: StepOne,
        name: 'step-1'
    }, {
        path: '/onderzoek/:token/stap-2',
        component: StepTwo,
        name: 'step-2'
    }, {
        path: '/onderzoek/:token/stap-3',
        component: StepThree,
        name: 'step-3'
    }, {
        path: '/onderzoek/:token/stap-4',
        component: StepFour,
        name: 'step-4'
    }, {
        path: '/onderzoek/:token/stap-5',
        component: StepFive,
        name: 'step-5'
    }, {
        path: '/onderzoek/:token/stap-6',
        component: StepSix,
        name: 'step-6'
    }, {
        path: '/onderzoek/:token/stap-7',
        component: StepSeven,
        name: 'step-7'
    }, {
        path: '/onderzoek/:token/stap-8',
        component: StepEight,
        name: 'step-8'
    }, {
        path: '/onderzoek/:token/stap-9',
        component: StepNine,
        name: 'step-9'
    }, {
        path: '/onderzoek/:token/stap-10',
        component: StepTen,
        name: 'step-10'
    }, {
        path: '/onderzoek/:token/stap-11',
        component: StepEleven,
        name: 'step-11'
    }, {
        path: '/onderzoek/:token/stap-12',
        component: StepTwelve,
        name: 'step-12'
    }, {
        path: '/onderzoek/:token/stap-13',
        component: StepThirteen,
        name: 'step-13'
    }, {
        path: '/onderzoek/:token/stap-14',
        component: StepFourteen,
        name: 'step-14'
    }, {
        path: '/onderzoek/:token/stap-15',
        component: StepFifteen,
        name: 'step-15'
    }, {
        path: '/onderzoek/:token/stap-16',
        component: StepSixteen,
        name: 'step-16'
    }, {
        path: '/onderzoek/:token/stap-17',
        component: StepSeventeen,
        name: 'step-17'
    }, {
        path: '/onderzoek/:token/stap-18',
        component: StepEighteen,
        name: 'step-18'
    }, {
        path: '/onderzoek/:token/afronden',
        component: Start,
        name: 'complete-inquiry'
    }, {
        path:'/onderzoek/:token/verlopen',
        component: Expired,
        name: 'inquiry-expired'
    }
]

export default inquiry
